var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fadeIn"},[[_vm._m(0)]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Page Not Found")])])
}]

export { render, staticRenderFns }